// Hình thức kí số
export default {
  RemoteSigning: 0, // Ký bằng esign
  USBToken: 1, // Ký bằng usb token
};
